module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{},"en":{},"ja":{},"ko":{}}')
  delete Component.options._Ctor
}
